
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import ItiToolbarOkCancel from '../toolbar-ok-cancel/iti-toolbar-ok-cancel.vue';
import { ValidationObserver } from 'vee-validate';
import EventBusType, { EventBus } from '@/shared/services/event-bus';

@Component({
    components: {
        ItiToolbarOkCancel,
        ValidationObserver,
    }
})

export default class ItiForm extends Vue {
    @Prop() public title!: string;
    @Ref('validationObserver') public validationObserver: any;

    public created() {
        EventBus.$on(EventBusType.cleanValidators, () => {
            if (this.validationObserver) {
                this.validationObserver.reset()
            }
        });
    }

    public closeModal() {
        this.$emit('cancel');
    }

    public async submit() {
        const allOk = await this.validationObserver.validate();
        //console.log(allOk);
        if (allOk) {
            this.$emit('ok');
        }
    }

}
